var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
import { getAppThemeName } from "../../Services/appTheme";
const StyledInputWrapper = styled.div `
    position: relative;
    display: inline-block;
    margin-right: 10px;
`;
const StyledInput = styled.input `
    position: absolute;
    z-index: 0;

    &:checked + label {
        color: ${color.body.base};
        border-color: ${(props) => props.theme.primary};
        background-color: ${(props) => props.theme.primary};
    }
    &:checked:disabled {
        display: none;

        + label {
            opacity: 0.5;
        }
    }
`;
const StyledLabel = styled.label `
    transition: all 0.2s ease-in-out;
    position: relative;
    display: block;
    padding: 10px 20px;
    border-radius: 7px;
    background-color: ${color.gray.lighter};
    border: 1px solid ${color.gray.light};
    color: ${color.gray.dark};
    font-weight: ${(props) => (props.appTheme === "invoned" ? 500 : 600)};
    cursor: pointer;
    z-index: 1;

    @media only screen and (min-width: 768px) {
        padding: 20px 30px;
    }
`;
const InputRadio = (_a) => {
    var { label, value, name, id, checked, onChange, className, error, tooltipContents } = _a, restProps = __rest(_a, ["label", "value", "name", "id", "checked", "onChange", "className", "error", "tooltipContents"]);
    const [fid] = useState(id || _.uniqueId("field-"));
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInputWrapper, { className: className },
            React.createElement(StyledInput, Object.assign({ type: "radio", name: name, id: fid, value: value, checked: checked, onChange: onChange }, restProps)),
            React.createElement(StyledLabel, { htmlFor: fid, appTheme: getAppThemeName() }, label)),
        !!error && React.createElement(ErrorLabel, null, _.capitalize(error))));
};
export default InputRadio;
